import { networkTracer } from "@autotracer/network";
networkTracer({});